import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { computed, ref } from 'vue';
import { UploadType } from '@/gql/graphql';
import { BAlert, BBadge, BButton, BModal } from 'bootstrap-vue-next';
import { formatFileName } from '@/utils/file-utils';

// --- Component properties ---

export default /*@__PURE__*/_defineComponent({
  __name: 'UploadResume',
  props: {
    show: { type: Boolean },
    upload: {}
  },
  emits: ['close', 'success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// --- Component emits ---
const emits = __emit;

// --- Component state ---
const fileSelected = ref<File | null>(null);
const resumeError = ref<string | null>(null);
const resumeShowSuccess = ref<boolean>(false);
const show = computed<boolean>(() => {
  return props.show;
});

// Create a ref for the hidden file input
const fileInput = ref<HTMLInputElement | null>(null);

// Trigger the file input dialog
function triggerFileSelect() {
  fileInput.value?.click();
}

// When the file input changes, update our fileSelected
function handleFileSelected(e: Event) {
  const target = e.target as HTMLInputElement;

  if (target.files && target.files.length > 1) {
    resumeError.value = 'Please select only one file';
    fileSelected.value = null;
    return;
  } else if (target.files && target.files.length === 1) {
    // check names match
    if (target.files[0].name !== formatFileName(props.upload.sourceFileName)) {
      resumeError.value =
        'File name ' +
        target.files[0].name +
        ' does not match ' +
        formatFileName(props.upload.sourceFileName);
      fileSelected.value = null;
      return;
    } else if (target.files[0].size.toString() !== props.upload.size) {
      resumeError.value =
        'File size does not match: ' +
        target.files[0].size +
        ' is not equal to ' +
        props.upload.size;
      fileSelected.value = null;
      return;
    }

    // file selection successful
    resumeError.value = null;
    fileSelected.value = target.files[0];
  }
}

// --- Handle user actions ---
function onFileSelectionConfirmed() {
  if (fileSelected.value) {
    emits('success', fileSelected.value);
  }
}

function handleCloseModal() {
  emits('close');
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      type: "file",
      ref_key: "fileInput",
      ref: fileInput,
      style: {"display":"none"},
      onChange: handleFileSelected
    }, null, 544),
    _createVNode(_unref(BModal), {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      onHide: handleCloseModal
    }, {
      title: _withCtx(() => [
        _createVNode(_component_font_awesome_icon, {
          icon: "rotate-right",
          class: "me-2"
        }),
        _cache[2] || (_cache[2] = _createTextVNode(" Resume upload ", -1))
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(BButton), {
          variant: "secondary",
          onClick: handleCloseModal
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" Cancel ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(BButton), {
          variant: "primary",
          disabled: !fileSelected.value || resumeError.value,
          onClick: onFileSelectionConfirmed
        }, {
          default: _withCtx(() => [
            (resumeShowSuccess.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  _cache[7] || (_cache[7] = _createTextVNode(" Upload Request Registered ", -1)),
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fa', 'check-double'],
                    class: "me-2"
                  })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, " Resume Upload "))
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" Please select the file from your file system to resume the upload of ", -1)),
            _createElementVNode("strong", null, _toDisplayString(_unref(formatFileName)(props.upload.sourceFileName)), 1),
            _cache[4] || (_cache[4] = _createTextVNode("? ", -1))
          ]),
          _createVNode(_unref(BButton), {
            variant: "outline-primary",
            onClick: triggerFileSelect
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Select File ", -1)
            ]))]),
            _: 1
          }),
          (fileSelected.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(BBadge), { variant: "success" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Selected file: " + _toDisplayString(fileSelected.value.name), 1)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(BAlert), {
            modelValue: resumeError.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((resumeError).value = $event)),
            variant: "danger",
            class: "mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(resumeError.value), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})